// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24PLO","col":"styles_col__1ad1l"};